"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function setSourceUpdateStatus(sourceId, status) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_SOURCE_UPDATE_STATUS, {
    sourceId: sourceId,
    status: status
  });
}
var _default = exports["default"] = setSourceUpdateStatus;